/**
 * Created by gavorhes on 12/14/2015.
 */
import quickMap from "./webmapsjsdist/quickMap";
import mapMove from "./webmapsjsdist/mapMove";
import LayerLegend from "./webmapsjsdist/LayerLegend";
import {extentObject} from "./webmapsjsdist/mapMoveCls";
import {TipSliders, TipPresetConfig, TipSliderConfig} from "./webmapsjsdist/Sliders";
import {ItsLayerCollection} from "./webmapsjsdist/ItsLayerCollection";
import {TipSegmentLayer} from "./TipSegmentLayer";
import {LayerEsriMapServer, makeServiceUrl} from "./webmapsjsdist/LayerEsriMapServer";
import {LayerBase} from "./webmapsjsdist/LayerBase";
import $ = require('jquery');
import Map from 'ol/Map';
import * as conf from './config';
import {post, get} from "./webmapsjsdist/axios";
import makeGuid from "./webmapsjsdist/makeGuid";

window['$'] = $;

/**
 * Tip config object
 */


conf.tipConfig.$presetSelector.append('<option value="0" disabled=>Custom</option>');

const uiSetup = {
    startUi: function () {

        conf.tipConfig.$loadingGif = $('#loading-gif');
        conf.tipConfig.$loadingGif.fadeIn();

        //enable get help button
        $('#tip-help').click(function () {

            let win = window.open('tip/help', '_blank');
            if (win) {
                win.focus();
            } else {
                alert('Please allow popups for this site');
            }
        });
    },
    endUi: function () {
        conf.tipConfig.$loadingGif.fadeOut();
        conf.tipConfig.$presetSelector.val('1');

        $('#make-report').click(function () {
            let params = mapMove.mapExtent;
            params['paramWeights'] = JSON.stringify(conf.tipConfig.sliders.getParams());
            params['region'] = $('#region-selector').val();
            params['preset'] = $('#preset-selector').find('option:selected').text();
            params['version'] = $('#version-selector').val();

            let win = window.open('tip/getreport?' + $.param(params), '_blank');
            if (win) {
                //Browser has allowed it to be opened
                win.focus();
            } else {
                //Browser has blocked it
                alert('Please allow popups for this site');
            }
        });


        $('#report-all-presets').click(function (){
            // console.log('here');

            let params = mapMove.mapExtent;


            // params['paramWeights'] = JSON.stringify(conf.tipConfig.sliders.getParams());
            // params['region'] = $('#region-selector').val();
            // params['preset'] = $('#preset-selector').find('option:selected').text();
            params['version'] = $('#version-selector').val();

            console.log(params)

            // post('getreportfile', (d: { file?: string, error?: string }) => {
            get('tip/getpresetreport', (d: { file?: string, error?: string }) => {

                console.log('got response');
                console.log(d);

                if (d.error) {
                    alert(d.error)
                } else {
                    let newId = makeGuid();
                    let html = `<a id="${newId}" href="${d.file}" `;
                    // html += `style="display: none"`;

                    if (d.file.search(/\.xlsx?$/) > -1) {
                        html += 'type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" download="tsmo-report.xlsx"';
                    } else {
                        html += 'type="application/pdf" download="tsmo-report.pdf"';
                    }

                    html +=  ' target="_blank"';


                    //
                    // if (b.name.toLocaleLowerCase() === 'ie') {
                    //     html += ' target="_blank"';
                    // } else {
                    //     if (d.file.search(/\.xlsx?$/) > -1) {
                    //         html += 'type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" download="tsmo-report.xlsx"';
                    //     } else {
                    //         html += 'type="application/pdf" download="tsmo-report.pdf"';
                    //     }
                    // }

                    html += `>${newId}</a>`;

                    $('#link-container').append(html);


                    setTimeout(() => {
                        document.getElementById(newId).click();
                    }, 20);
                }
            }, params, (d) => {
                console.log(d)
            });



        })



        $('#make-region-report').click(function () {

            /**
             *                     <option value="SE">Southeast</option>
                    <option value="SW">Southwest</option>
                    <option value="NW">Northwest</option>
                    <option value="NC">North Central</option>
                    <option value="NE">Northeast</option>
             */

            let c = 0;

            let regions = ['SE', 'SW', 'NW', 'NC', 'NE'];

            let params = mapMove.mapExtent;
            params['paramWeights'] = JSON.stringify(conf.tipConfig.sliders.getParams());
            params['preset'] = $('#preset-selector').find('option:selected').text();
            params['version'] = $('#version-selector').val();
            params['download'] = 'true';
            let l = document.getElementById('report-list');

            l.innerHTML = '';

            for (let r of regions){

                params['region'] = r;


                let a = document.createElement('a') as HTMLAnchorElement;
                let li = document.createElement('li') as HTMLLIElement;

                a.href = 'tip/getreport?' + $.param(params);
                a.innerHTML = r;
                a.target = '_blank';
                a.className = 'region-report-links';
                li.appendChild(a);
                l.appendChild(li);
            }

            let links = document.getElementsByClassName('region-report-links')

            let j = 1;

            if (links.length > 0) {
                window.open((links[0] as HTMLAnchorElement).href, '_blank');
                window.focus();
            }


            let interv = setInterval(() => {


                if (j > links.length - 1){
                    clearInterval(interv);
                    return;
                }

                let lnk = links[j] as HTMLAnchorElement;

 //                var evt = document.createEvent("MouseEvents");
 //                    evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0,true, false, false, false, 0, null);
 // lnk.dispatchEvent(evt);
                // lnk.click();

                window.open(lnk.href, '_blank');
                window.focus();
                console.log(lnk.href)

                j++;





                // params['region'] = regions[j];
                //
                //
                // let a = document.createElement('a') as HTMLAnchorElement;
                // let li = document.createElement('li') as HTMLLIElement;
                //
                // a.href = 'tip/getreport?' + $.param(params);
                // a.innerHTML = regions[j];
                // a.target = '_blank';
                // a.className = 'region-report-links';
                // li.appendChild(a);
                // l.appendChild(li);

                // a.click();


                // console.log('tip/getreport?' + $.param(params));
                //
                // let win = window.open('tip/getreport?' + $.param(params), '_blank');
                // if (win) {
                //     //Browser has allowed it to be opened
                //     win.focus();
                // } else {
                //     //Browser has blocked it
                //     alert('Please allow popups for this site');
                // }


                // j++;
                // if (j > 4){
                //     clearInterval(interv);
                // }

            }, 120000)
            // let params = mapMove.mapExtent;
            // params['paramWeights'] = JSON.stringify(conf.tipConfig.sliders.getParams());
            // params['region'] = $('#region-selector').val();
            // params['preset'] = $('#preset-selector').find('option:selected').text();
            // params['version'] = $('#version-selector').val();
            //
            // let win = window.open('tip/getreport?' + $.param(params), '_blank');
            // if (win) {
            //     //Browser has allowed it to be opened
            //     win.focus();
            // } else {
            //     //Browser has blocked it
            //     alert('Please allow popups for this site');
            // }
        });
    },
    endUiMap: function () {

        mapMove.addCallback(function (ext: extentObject, zoom: number) {
            $('#make-report').prop('disabled', !(zoom >= conf.tipConfig.tipSegmentLayerMinZoom));
            $('#report-all-presets').prop('disabled', !(zoom >= conf.tipConfig.tipSegmentLayerMinZoom));
        }, this);

        let layerArray = [
            conf.tipConfig.tipSegmentLayer,
            conf.tipConfig.metamanagerSegments,
            conf.tipConfig.sixYearPlanLayer,
            {
                groupName: 'ITS Inventory Layers',
                collapse: true,
                addCheck: false,
                items: conf.tipConfig.itsLayerCollection.layers
            }
        ];

        let legend = new LayerLegend(layerArray as LayerBase[], 'legend-container', {});

        $(window).keyup(function (e) {
            let ext = conf.tipConfig._map.getView().calculateExtent(conf.tipConfig._map.getSize());
            let cent = conf.tipConfig._map.getView().getCenter();
            let shift_horiz = (ext[2] - ext[0]) / 10;
            let shift_vert = (ext[3] - ext[1]) / 10;

            switch (e.keyCode) {
                //up
                case 38:
                    conf.tipConfig._map.getView().setCenter([cent[0], cent[1] + shift_vert]);
                    break;
                // down
                case 40:
                    conf.tipConfig._map.getView().setCenter([cent[0], cent[1] - shift_vert]);
                    break;
                // left
                case 37:
                    conf.tipConfig._map.getView().setCenter([cent[0] - shift_horiz, cent[1]]);
                    break;
                //right
                case 39:
                    conf.tipConfig._map.getView().setCenter([cent[0] + shift_horiz, cent[1]]);
                    break;
                default:
                    break;
            }
        })
    }
};


export function metamanagerTipMain() {
    uiSetup.startUi();

    let sliders = new TipSliders(conf.tipConfig.slidersConfig, conf.tipConfig.presetConfig, 'slider-container',
        conf.tipConfig.$presetSelector, conf.tipConfig.$regionSelector, conf.tipConfig.$versionSelector);
    conf.tipConfig.sliders = sliders;

    let map = quickMap({minZoom: 7});
    conf.tipConfig._map = map;

    let wisDotRegions = new LayerEsriMapServer(
        makeServiceUrl('MetaManager', 'Metamanager_regions'),
        {
            minZoom: 6,
            maxZoom: 12,
            name: 'WisDOT Regions',
            opacity: 0.3
        });

    map.addLayer(wisDotRegions.olLayer);

    let options = {
        selectionStyle: {
            color: 'rgba(0,0,255,0.5)',
            width: 7
        },
        $loadingGif: conf.tipConfig.$loadingGif,
        minZoom: conf.tipConfig.tipSegmentLayerMinZoom
    };

    // new LayerBaseVectorGeoJson('tip/gettipfeatures?callback=?', options);


    conf.tipConfig.tipSegmentLayer = new TipSegmentLayer(conf.tipConfig.sliders,
        {
            selectionStyle: {
                color: 'rgba(0,0,255,0.5)',
                width: 7
            },
            $loadingGif: conf.tipConfig.$loadingGif,
            minZoom: conf.tipConfig.tipSegmentLayerMinZoom
        }
    );

    map.addLayer(conf.tipConfig.tipSegmentLayer.olLayer);

    conf.tipConfig.metamanagerSegments = new LayerEsriMapServer(
        makeServiceUrl('MetaManager', 'MM_All_Segments'),
        {
            minZoom: 8,
            visible: false,
            name: 'Metamanager Segments'
        });
    map.addLayer(conf.tipConfig.metamanagerSegments.olLayer);

    conf.tipConfig.sixYearPlanLayer = new LayerEsriMapServer(makeServiceUrl('MetaManager', 'SixYearPlan'),
        {name: 'Six Year Plan', legendCollapse: true, visible: false});

    map.addLayer(conf.tipConfig.sixYearPlanLayer.olLayer);

    conf.tipConfig.itsLayerCollection = new ItsLayerCollection(map);

    sliders.changedCallback = () => {
        mapMove.triggerLyrLoad(conf.tipConfig.tipSegmentLayer);
    };

    uiSetup.endUi();
    uiSetup.endUiMap();
}

metamanagerTipMain();
